import { useAuth } from '~/auth/auth-context'
import { LogoMark } from '~/components/icons'
import { WorkingButton } from '~/components/working'

/**
 * What an account whose plan has no cloud sees, and the whole of what it sees — the app spec,
 * Signing in. This web app is a window onto what the server holds, so an account that keeps
 * nothing there has nothing here to look at; saying which plans there are is more use than a
 * timeline with nothing in it and no reason given.
 */
export function UpgradePage() {
  const { signOut } = useAuth()

  return (
    <main className="flex min-h-dvh flex-col items-center justify-center gap-8 bg-surface px-6 py-12 text-ink">
      <div className="flex flex-col items-center gap-4 text-center">
        <LogoMark className="h-12 w-auto text-ink" />
        <h1 className="text-3xl font-semibold tracking-[-0.03em] text-balance sm:text-4xl">
          This one needs the cloud
        </h1>
        <p className="max-w-md text-base text-ink-muted text-balance">
          Your plan keeps everything on your phone, so there is nothing here to show. The web app
          reads what is kept in the cloud.
        </p>
      </div>

      <ul className="grid w-full max-w-2xl gap-4 sm:grid-cols-2">
        <li className="space-y-3 rounded-2xl bg-surface-raised p-5 ring-1 ring-white/10">
          <h2 className="text-lg font-semibold">Free</h2>
          <ul className="space-y-1.5 text-sm text-ink-muted">
            <li>The app on your phone</li>
            <li>No cloud backup</li>
            <li>No AI</li>
          </ul>
        </li>
        <li className="space-y-3 rounded-2xl bg-surface-raised p-5 ring-1 ring-accent/40">
          <h2 className="text-lg font-semibold">Pro</h2>
          <ul className="space-y-1.5 text-sm text-ink-muted">
            <li>Cloud backup of everything you log</li>
            <li>This web app</li>
            <li>Room for your videos</li>
            <li>An AI allowance every month</li>
          </ul>
        </li>
      </ul>

      <p className="max-w-md text-center text-sm text-ink-muted text-balance">
        Plans are not for sale yet. When they are, this is where upgrading will be.
      </p>

      <WorkingButton
        className="rounded-full px-5 py-2 text-sm font-medium text-accent transition-colors hover:bg-hover"
        onPress={signOut}
      >
        Sign out
      </WorkingButton>
    </main>
  )
}
